/* Debug tracing that stays out of production render paths.
   Enable in the field with: localStorage.setItem('iconDebug', '1') */
export function debugLog(...args: unknown[]): void {
  let enabled = process.env.NODE_ENV === 'development';
  if (!enabled) {
    // localStorage access can THROW in sandboxed/privacy-restricted iframes —
    // and this app always runs in an iframe. A logger must never crash the app.
    try {
      enabled = localStorage.getItem('iconDebug') === '1';
    } catch {
      enabled = false;
    }
  }
  if (enabled) console.log(...args);
}
